// // @flow

import axios from "axios";
import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import * as Sentry from "@sentry/react";

const baseURL = process.env.REACT_APP_ENDPOINT;
const instance = axios.create({
  baseURL: baseURL,
  params: {
    access_token: localStorage.getItem("authToken"),
  }
});


const AxiosInterceptor = ({ children }) => {
  const { logout, token } = useAuth(); 
  useEffect(() => {
    const reqInterceptor = (config) => {
      const authToken = token || localStorage.getItem("authToken");
      if (authToken) {
        config.params = config.params || {};
        config.params['access_token'] = authToken;
      }
      return config;
    };

    const resInterceptor = (response) => {
      return response;
    };

    const errInterceptor = (error) => {
      if (error.response) {
        
        Sentry.captureException(error, {
          extra: {
            requestData: error.config?.data || error.config?.params, 
            requestUrl: error.config?.url,  
            requestMethod: error.config?.method, 
            responseData: error.response?.data, 
            statusCode: error.response?.status, 
          },
        });

        if (error.response.status === 401) {
          logout();
        }
      } else {
        Sentry.captureException(new Error("Network or unknown error: " + error.config?.url, {
          extra: {
            requestData: error.config?.data || error.config?.params, 
            requestUrl: error.config?.url,
            requestMethod: error.config?.method,
          },
        }));
      }

      return Promise.reject(error);
    };

    const requestInterceptor = instance.interceptors.request.use(reqInterceptor);
    const responseInterceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    return () => {
      instance.interceptors.request.eject(requestInterceptor);
      instance.interceptors.response.eject(responseInterceptor);
    };
  });

  return children;
};

export default instance;
export { AxiosInterceptor };
